import { useEffect, useState } from "react";

export function setIsHomepageLogged(isLogged: boolean) {
  window.localStorage.setItem("isHomepageLogged", JSON.stringify(isLogged));
  window.dispatchEvent(new Event("isHomepageLoggedChanged"));
}

function getIsHomepageLogged() {
  const isLogged = window.localStorage.getItem("isHomepageLogged");
  return isLogged ? JSON.parse(isLogged) : false;
}

export default function useHomepageIsLogged() {
  const [isLogged, setIsLogged] = useState<boolean>(getIsHomepageLogged());
  useEffect(() => {
    const handler = () => {
      setIsLogged(getIsHomepageLogged());
    };
    window.addEventListener("isHomepageLoggedChanged", handler);
    return () => window.removeEventListener("isHomepageLoggedChanged", handler);
  }, []);

  return isLogged;
}
